import React from "react";
import { Row, Col, DatePicker, Radio, Spin, Divider } from "antd";
import "../../vitals/Vital-Scss/bloodpressure.scss";
import { subDays, format } from "date-fns";
import Barchart from "../Barchart";
import VitalsTable from "./table";

const { RangePicker } = DatePicker;
// const { RangePicker } = TimePicker;

export default class BloodPressure extends React.Component {
  //Clueless Constructor
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      data: [],
      Diastolic: "",
      Systolic: "",
      filteredData: [],
      d: "",
      s: "",
      loader: true,
      // toggle:this.props.toggle
    };
  }

  handleChange = (date, dateString) => {
    this.setState(
      {
        filteredData: dateString[1],
        d: dateString[0],
        s: dateString[1],
        loader: false,
      },
      () => {
        const { d, s } = this.state;
        const pid = this.props.p_id;
        console.log(d);
        fetch(
          `https://app02.thbglobal.com/v1/patients/${pid}/vitals/bloodpressure?startDate=${d}&endDate=${s}`,
          {
            headers: {
              "x-api-key": `Bearer ${JSON.parse(
                localStorage.getItem("tokens")
              )}`,
            },
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.type === "Success") {
              this.setState({
                data: data.data,
                loader: true,
              });
            } else {
              this.setState({
                loader: true,
              });
            }
          });
      }
    );
  };

  onChange = (e) => {
    console.log("radio checked", e.target.value);
    this.setState({
      value: e.target.value,
    });
    const today = format(new Date(), "yyyy-MM-dd");
    if (e.target.value == 1) {
      let past_week = format(subDays(new Date(), 7), "yyyy-MM-dd");
      this.handleChange("", [past_week, today]);
    } else if (e.target.value == 2) {
      let past_month = format(subDays(new Date(), 30), "yyyy-MM-dd");
      this.handleChange("", [past_month, today]);
    } else {
      let past_year = format(subDays(new Date(), 365), "yyyy-MM-dd");
      this.handleChange("", [past_year, today]);
    }
  };

  handleSplit = () => {
    const data = this.state.data;
    data.forEach((element) =>
      this.setState({
        Diastolic: element.vital_reading.substring(
          element.vital_reading.indexOf(",")
        ),
        Systolic: element.vital_reading.substring(
          element.vital_reading.indexOf(",")
        ),
      })
    );
  };

  month = format(subDays(new Date(), 30), "yyyy-MM-dd");

  componentDidMount() {
    const today = format(new Date(), "yyyy-MM-dd");
    let past_month = format(subDays(new Date(), 30), "yyyy-MM-dd");
    this.handleChange("", [past_month, today]);
    this._ismounted = true;
  }

  componentDidUpdate() {
    if (sessionStorage.getItem("activeTab") !== 1) {
      sessionStorage.setItem("activeTab", 1);
    }
    // if(this.state.toggle !== prevProps.toggle){
    // const today =format(new Date(),'yyyy-MM-dd');
    // let past_month = format(subDays(new Date(),30),'yyyy-MM-dd');
    // this.handleChange("",[past_month, today] );
    // this._ismounted = true;
    // }
  }

  componentWillUnmount() {
    this._ismounted = false;
    sessionStorage.clear();
  }

  render() {
    sessionStorage.setItem("activeTab", 1);
    const data = [...this.state.data];
    return (
      <>
        <Row gutter={16}>
          <Col span={24} className="date-picker-container">
            <RangePicker
              onChange={(date, dateString) => {
                this.handleChange(date, dateString);
              }}
            />
            <hr />
            <Radio.Group
              name="radiogroup"
              onChange={this.onChange}
              value={this.value}
              style={{
                background: "#08aca4",
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <Radio value={1}>Week</Radio>
              <Radio value={2}>Month</Radio>
              <Radio value={3}>Year</Radio>
            </Radio.Group>
          </Col>
          {this.state.loader ? (
            <Col span={24} className="bar-chart-col">
              <Barchart data={data} />
            </Col>
          ) : (
            <Spin
              size="large"
              style={{ position: "absolute", top: "50%", left: "50%" }}
            />
          )}
        </Row>
        <Divider />
        <VitalsTable vitalsLoader={this.state.loader} data={data} />
      </>
    );
  }
}
